import { useEffect } from 'react';
import useDeleteAutomation from '@/hooks/api/automations/useDeleteAutomation.ts';
import ConfirmationModal from '@/components/ConfirmationModal.tsx';
import { Automation } from '@/types/automations.ts';

type DeleteAutomationDialogProps = {
  automation: Automation;
  onClose: () => void;
};

const DeleteAutomationModal = ({ automation, onClose }: DeleteAutomationDialogProps) => {
  const { mutate: deleteAutomation, isPending, isSuccess } = useDeleteAutomation();

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <ConfirmationModal
      opened={true}
      onClose={onClose}
      title={'Delete Automation'}
      onConfirm={() => deleteAutomation({ id: automation.id })}
      confirmLoading={isPending}
      closeOnConfirm={false}
      message={`Are you sure you want to delete "${automation.name}"?`}
      confirmText={'Delete'}
      confirmType={'delete'}
    />
  );
};

export default DeleteAutomationModal;
